import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../../../../../services/login/login.service';
import { DataAddress } from '../../../../../../../views/clientes/model/DataAddress';
import { AddressService } from '../../../utils/services/address.service';

@Component({
  selector: 'app-form-address',
  templateUrl: './form-address.component.html',
  styleUrls: ['./form-address.component.scss']
})
export class FormAddressComponent implements OnInit {
  public dataAddres: DataAddress;
  public formulario: FormGroup;
  public loading = false;
  public success = false;
  public colonias: [] = [];
  public errorCP: string;
  public changeText: boolean;

  constructor(
    private dialogRef: MatDialogRef<FormAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: FormBuilder,
    private servicioAddress: AddressService,
    private loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.dataAddres = this.data.dataForm;
    this.buildForm();
  }

  private buildForm = (): void => {
    if (this.data.opcion === 'editar') {
      this.buildFormEdit();
    } else {
      this.buildFormAdd();
    }
  }

  private buildFormAdd = (): void => {
    console.log('is pg', this.loginService.isPublicoGeneral);

    if (this.loginService.isPublicoGeneral()) {

      this.formulario = this.formBuilder.group({
        nombre: ['', [Validators.required, Validators.minLength(3)]],
        telefono: ['', [Validators.required, Validators.minLength(10)]],
        calle: ['', [Validators.required, Validators.minLength(3)]],
        numExterior: ['', [Validators.required, Validators.minLength(2)]],
        numInterior: ['', [Validators.minLength(1)]],
        calle1: ['', [Validators.required, Validators.minLength(3)]],
        calle2: ['', [Validators.required, Validators.minLength(3)]],
        codigoPostal: ['', [Validators.required, Validators.minLength(3)]],
        colonia: ['', [Validators.required, Validators.minLength(3)]],
        ciudad: ['', [Validators.required, Validators.minLength(3)]],
        estado: ['', [Validators.required, Validators.minLength(3)]],
        municipio: ['', [Validators.required, Validators.minLength(3)]],
        referencia: ['', Validators.minLength(3)],
        horarioEntrada: ['', Validators.required],
        horarioSalida: ['', Validators.required],
      });

    } else {


      this.formulario = this.formBuilder.group({
        nombre: ['', [Validators.required, Validators.minLength(3)]],
        telefono: ['', [Validators.required, Validators.minLength(10)]],
        calle: ['', [Validators.required, Validators.minLength(3)]],
        numExterior: ['', [Validators.required, Validators.minLength(2)]],
        numInterior: ['', [Validators.minLength(1)]],
        calle1: ['', [Validators.required, Validators.minLength(3)]],
        calle2: ['',  /*[Validators.required,Validators.minLength(3)]*/],
        codigoPostal: ['', [Validators.required, Validators.minLength(3)]],
        colonia: ['', [Validators.required, Validators.minLength(3)]],
        ciudad: ['', [Validators.required, Validators.minLength(3)]],
        estado: ['', [Validators.required, Validators.minLength(3)]],
        municipio: ['', [Validators.required, Validators.minLength(3)]],
        referencia: ['', Validators.minLength(3)],
        horarioEntrada: [''/* Validators.required*/],
        horarioSalida: ['' /*Validators.required*/],
      });
    }
  }

  private buildFormEdit = (): void => {
    this.getCPApi(this.dataAddres.codigoPostal);
    if (this.loginService.isPublicoGeneral()) {

      this.formulario = this.formBuilder.group({
        nombre: [this.dataAddres.nombre, [Validators.required, Validators.minLength(3)]],
        telefono: [this.dataAddres.telefono, [Validators.required, Validators.minLength(10)]],
        calle: [this.dataAddres.calle, [Validators.required, Validators.minLength(3)]],
        numExterior: [this.dataAddres.numExterior, [Validators.required, Validators.minLength(2)]],
        numInterior: [this.dataAddres.numInterior, [Validators.minLength(1)]],
        calle1: [this.dataAddres.calle1, [Validators.required, Validators.minLength(3)]],
        calle2: [this.dataAddres.calle2, [Validators.required, Validators.minLength(3)]],
        codigoPostal: [this.dataAddres.codigoPostal, [Validators.required, Validators.minLength(3)]],
        ciudad: [this.dataAddres.ciudad, [Validators.required, Validators.minLength(3)]],
        estado: [this.dataAddres.estado, [Validators.required, Validators.minLength(3)]],
        municipio: [this.dataAddres.municipio, [Validators.required, Validators.minLength(3)]],
        colonia: [this.dataAddres.colonia, [Validators.required, Validators.minLength(3)]],
        horarioEntrada: [this.dataAddres.horarioEntrada, Validators.required],
        horarioSalida: [this.dataAddres.horarioSalida, Validators.required],
        referencia: [this.dataAddres.referencia, Validators.minLength(3)],
      });
    } else {
      this.formulario = this.formBuilder.group({
        nombre: [this.dataAddres.nombre, [Validators.required, Validators.minLength(3)]],
        telefono: [this.dataAddres.telefono, [Validators.required, Validators.minLength(10)]],
        calle: [this.dataAddres.calle, [Validators.required, Validators.minLength(3)]],
        numExterior: [this.dataAddres.numExterior, [Validators.required, Validators.minLength(2)]],
        numInterior: [this.dataAddres.numInterior, [Validators.minLength(1)]],
        calle1: [this.dataAddres.calle1, [Validators.required, Validators.minLength(3)]],
        calle2: [this.dataAddres.calle2],
        codigoPostal: [this.dataAddres.codigoPostal, [Validators.required, Validators.minLength(3)]],
        ciudad: [this.dataAddres.ciudad, [Validators.required, Validators.minLength(3)]],
        estado: [this.dataAddres.estado, [Validators.required, Validators.minLength(3)]],
        municipio: [this.dataAddres.municipio, [Validators.required, Validators.minLength(3)]],
        colonia: [this.dataAddres.colonia, [Validators.required, Validators.minLength(3)]],
        horarioEntrada: [this.dataAddres.horarioEntrada],
        horarioSalida: [this.dataAddres.horarioSalida],
        referencia: [this.dataAddres.referencia],
      });
    }
    // marcamos como tocados los input para que se vean en verde
    this.formulario.markAllAsTouched();
  }

  public submit = (event): void => {
    event.preventDefault();
    this.loading = true;
    console.log('is sub', this.formulario);

    // HABILITAMOS LOS CAMPOS DE ESTADO CIUDAD ETC.
    this.enabledInput(); // ESTO ES POR QUE SI NO LO HACEMOS EL FORMULARIO LOS TOMA COMO SI NO EXISTIERAN
    if (this.formulario.valid) { // VALIDAMOS EL FORMULARIO
      const data = this.formulario.value;
      // HACEMOS LA VALIDACIÓN DEPENDIENDO DE DONDE ENTRO
      // SI FUE POR EL BOTON DE EDITAR O EL DE AGREGAR
      if (this.data.opcion === 'editar') {
        // AQUÍ EDITAMOS LA DIRECCIÓN
        this.servicioAddress.updateAddress(data, this.dataAddres.id).subscribe(response => {
          if (response.message) {
            this.loading = false;
            this.success = true;
            setTimeout(() => {// ESTE DELAY ES PARA QUE CLIENTE VEA EL BOTON VERDE Y SEPA QUE SE ACTIALIZO
              this.dialogRef.close(true);
            }, 1200);
          }
        });
      } else {
        // AQUÍ AGREGAMOS UNA NUEVA DIRECCIÓN
        this.servicioAddress.addAddress(data).subscribe(response => {
          if (response.message) {
            this.loading = false;
            this.success = true;
            setTimeout(() => { // ESTE DELAY ES PARA QUE CLIENTE VEA EL BOTON VERDE Y SEPA QUE SE ACTIALIZO
              this.dialogRef.close(true);
            }, 1200);
          }
        });
      }
    } else {
      this.loading = false;
      this.formulario.markAllAsTouched();
      this.disabledInput();
    }
  }

  // metodo para validar si el input del codigo postal no esta vacio.
  public searchCP = (): void => {
    if (this.getCP() !== '') {
      this.getCPApi(this.getCP());
    }
  }

  // este metodo es para habilitar el campo colonia ya que si no esta habilitado no se valida con angular
  public focusCP = (): void => {
    this.formulario.get('colonia').enable();
  }

  // funcion para traer el CP del api
  public getCPApi = (cp: string): void => {
    this.servicioAddress.getCPApi(cp).subscribe((response) => {
      if (!response.error) {
        const dataResponse = response;
        this.setCiudad(dataResponse.ciudad);
        this.setEstado(dataResponse.estado);
        this.setMunicipio(dataResponse.municipio);
        this.markTouchedCP();
        this.colonias = (response.asentamiento);
        this.formulario.get('colonia').enable();
        this.errorCP = null;
      } else {
        this.errorCP = 'El CP esta mal escrito o no existe';
        this.colonias = [];
        this.enabledInput();
        this.cleanInput();
        this.changeText = true;
      }
    }, (error) => {
      // validamos si el api esta en funcionamiento o si arroja un error 500
      // si es así entonces convertimos el select en un input para que el usuario llene el campo
      if (error === 'false') {
        // this.formulario.get('colonia').disable();
        this.enabledInput();
        this.cleanInput();
        this.changeText = true;
      } else {
        this.errorCP = error;
        this.colonias = [];
      }
    });
  }

  // metodo para marcar como tocados los input relacionados con el Codigo Postal
  markTouchedCP = () => {
    this.formulario.get('municipio').markAsTouched();
    this.formulario.get('ciudad').markAsTouched();
    this.formulario.get('estado').markAsTouched();
  }

  // *** VALIDETE ***
  // metodos que se utilizaran para validar
  public isInValidateForm = (input: string): boolean => {
    return this.getInput(input).invalid && this.getInput(input).touched;
  }

  public isValidateForm = (input: string, length: number): boolean => {
    return this.getInput(input).valid && this.getInput(input).touched &&
      this.getInput(input).value.length > length;
  }

  // *** METODOS ENCAPSULADOS ****
  public getCP = (): string => {
    return this.formulario.get('codigoPostal').value;
  }
  public getInput = (input: string) => {
    return this.formulario.get(input);
  }
  public setCiudad = (ciudad: string): void => {
    this.formulario.get('ciudad').setValue(ciudad);
  }
  public setEstado = (ciudad: string): void => {
    this.formulario.get('estado').setValue(ciudad);
  }
  public setMunicipio = (ciudad: string): void => {
    this.formulario.get('municipio').setValue(ciudad);
  }

  // estos metodos son para habilitar y desabilitar los inputs
  private cleanInput = () => {
    this.formulario.get('ciudad').setValue('');
    this.formulario.get('estado').setValue('');
    this.formulario.get('municipio').setValue('');
  }

  private enabledInput = () => {
    this.formulario.get('ciudad').enable();
    this.formulario.get('estado').enable();
    this.formulario.get('municipio').enable();
  }

  private disabledInput = () => {
    // this.formulario.get('ciudad').disable();
    // this.formulario.get('estado').disable();
    // this.formulario.get('municipio').disable();
  }
}
